var map = {
	"./icon-account.svg": "5844",
	"./icon-add.svg": "b976",
	"./icon-alert.svg": "652c",
	"./icon-apple.svg": "2c68",
	"./icon-arrow.svg": "c757",
	"./icon-asmr.svg": "3409",
	"./icon-bad-language.svg": "9d38",
	"./icon-beep-sound.svg": "3f7c",
	"./icon-bits.svg": "6604",
	"./icon-category.svg": "c452",
	"./icon-check-circle.svg": "3f45",
	"./icon-check-v2.svg": "0954",
	"./icon-check.svg": "b3db",
	"./icon-circle-info.svg": "3d11",
	"./icon-circle-status.svg": "811f",
	"./icon-close.svg": "439c",
	"./icon-config.svg": "2bbb",
	"./icon-connected.svg": "f62c",
	"./icon-copy.svg": "0dec",
	"./icon-csgo.svg": "8df1",
	"./icon-discord-small.svg": "e390",
	"./icon-discord.svg": "f3a0",
	"./icon-edit.svg": "4191",
	"./icon-external-link.svg": "9b18",
	"./icon-externalLink.svg": "6113",
	"./icon-facebook-small.svg": "de03",
	"./icon-facebook.svg": "d391",
	"./icon-footer-volume.svg": "96f4",
	"./icon-fortnite.svg": "3213",
	"./icon-google.svg": "df4b",
	"./icon-gta.svg": "4f9a",
	"./icon-headphones-empty.svg": "bba7",
	"./icon-headphones-error.svg": "20a2",
	"./icon-headphones-off.svg": "d5ce",
	"./icon-headphones-on.svg": "37fc",
	"./icon-help.svg": "46b7",
	"./icon-hide.svg": "2a61",
	"./icon-import.svg": "32ee",
	"./icon-info.svg": "b38e",
	"./icon-input.svg": "0be8",
	"./icon-key.svg": "3f80",
	"./icon-list.svg": "b566",
	"./icon-lock-closed.svg": "a220",
	"./icon-lock.svg": "ae3b",
	"./icon-logo-voicemod.svg": "3356",
	"./icon-master-volume-off.svg": "1142",
	"./icon-master-volume-on.svg": "b84e",
	"./icon-mic-empty.svg": "8255",
	"./icon-mic-error.svg": "a342",
	"./icon-mic-off.svg": "4c63",
	"./icon-mic-on.svg": "1731",
	"./icon-microphone-off.svg": "07d2",
	"./icon-microphone-on.svg": "50d1",
	"./icon-mode-compact.svg": "4e9a",
	"./icon-mode-extended.svg": "deae",
	"./icon-obs.svg": "00aa",
	"./icon-order.svg": "5a13",
	"./icon-output.svg": "50c5",
	"./icon-overwatch.svg": "af00",
	"./icon-pause.svg": "0522",
	"./icon-play-pause.svg": "83d8",
	"./icon-play-stop.svg": "10fa",
	"./icon-play.svg": "f9a6",
	"./icon-plugins.svg": "f20d",
	"./icon-pubg.svg": "02dc",
	"./icon-queue-check.svg": "b4d0",
	"./icon-random-off.svg": "5a2e",
	"./icon-random-on.svg": "2c3b",
	"./icon-reddit-small.svg": "4ab5",
	"./icon-reddit.svg": "1a96",
	"./icon-refresh.svg": "d9e8",
	"./icon-reset.svg": "9361",
	"./icon-search.svg": "9df7",
	"./icon-secondlife.svg": "5bbc",
	"./icon-settings.svg": "3881",
	"./icon-share.svg": "5f20",
	"./icon-skype.svg": "8e47",
	"./icon-soundboard.svg": "f3bf",
	"./icon-steam.svg": "4822",
	"./icon-stop.svg": "523d",
	"./icon-streamdeck.svg": "af21",
	"./icon-streamlabs.svg": "1846",
	"./icon-sword.svg": "e2c5",
	"./icon-teamspeak.svg": "3690",
	"./icon-tiktok.svg": "a65f",
	"./icon-timer.svg": "1e0b",
	"./icon-trash.svg": "726f",
	"./icon-twitch-prime.svg": "3be3",
	"./icon-twitch.svg": "92d5",
	"./icon-twitter-small.svg": "3323",
	"./icon-twitter.svg": "5b0a",
	"./icon-update.svg": "7a8b",
	"./icon-valorant.svg": "e72d",
	"./icon-video-pause.svg": "8577",
	"./icon-video-play-hover.svg": "1213",
	"./icon-video-play.svg": "6056",
	"./icon-view.svg": "eedd",
	"./icon-voicelab.svg": "f3ed",
	"./icon-voices.svg": "cab4",
	"./icon-vrchat.svg": "7e9b",
	"./icon-warning.svg": "70dd",
	"./icon-xsplit.svg": "c79b",
	"./icon-youtube.svg": "3b14",
	"./icon-zoom.svg": "ecd8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b994";